import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import ResetPasswordRequestScreen from '../screens/ResetPasswordRequestScreen'
import { ensureUniversalLoginContext } from '@/utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('reset-password-request')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ResetPasswordRequestScreen />
    </StrictMode>,
  )
}

bootstrap()
